export const performancePhases = {
  base64_ms: 'Base64 decoding',
  decompress_ms: 'Decompression',
  parse_ms: 'JSON parsing',
  prepare_hashes_ms: 'Hash preparation',
  merge_ms: 'Diff merging',
  dispatch_ms: 'Redux dispatch',
  total_ms: 'Total processing'
};

let latest = null;
let context = { archiveMode: false, debugMode: false, pending: false };
const samples = [];

export const updatePerformanceContext = (values) => {
  context = { ...context, ...values };
};

export const startPerformanceMeasurement = (kind) => ({
  kind,
  startedAt: performance.now(),
  ...Object.fromEntries(Object.keys(performancePhases).map((key) => [key, 0])),
  diff_bytes: 0,
  changed_indices: 0
});

export const recordPerformanceMeasurement = (measurement, tick) => {
  const { startedAt, ...values } = measurement;
  latest = { ...values, tick, total_ms: performance.now() - startedAt };
  if (latest.kind !== 'diff') return;
  samples.push(latest);
  if (samples.length > 100) samples.shift();
};

const summarize = (records) => {
  const stats = {};
  for (const key of ['merge_ms', 'dispatch_ms', 'total_ms', 'diff_bytes', 'changed_indices']) {
    const values = records.map((record) => record[key]).sort((a, b) => a - b);
    stats[key] = {
      average: values.length ? values.reduce((sum, value) => sum + value, 0) / values.length : null,
      p95: values.length ? values[Math.ceil(values.length * 0.95) - 1] : null
    };
  }
  return { count: records.length, stats };
};

export const getPerformanceSnapshot = () => ({
  ...context,
  latest,
  recent: summarize(samples)
});
